import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { useAuth, API } from "@/App";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL fragment
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        toast.error("Authentication failed");
        navigate("/", { replace: true });
        return;
      }

      const sessionId = sessionIdMatch[1];
      const userType = localStorage.getItem("connectstar_user_type") || "influencer";

      try {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const response = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId, user_type: userType }
        );

        // Save token and login - token must be passed to login function
        login(response.data, response.data.token);
        localStorage.removeItem("connectstar_user_type");
        toast.success("Welcome to Foundstar!");
        
        // Small delay to ensure token is saved before navigation
        await new Promise(resolve => setTimeout(resolve, 100));

        // Redirect based on user type
        if (response.data.user_type === "influencer") {
          navigate("/influencer/home", { replace: true });
        } else {
          navigate("/brand/home", { replace: true });
        }
      } catch (error) {
        console.error("Auth error:", error);
        toast.error("Authentication failed. Please try again.");
        navigate("/", { replace: true });
      }
    };

    processAuth();
  }, [navigate, login]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-[#FF69B4] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-[#64748B]">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
